import { render, staticRenderFns } from "./CoachGroup.vue?vue&type=template&id=4401dad4&"
import script from "./CoachGroup.vue?vue&type=script&lang=js&"
export * from "./CoachGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports